module.exports = __webpack_public_path__ + "img/signature_founder.5d3299d9.png";